type Props = {
  imagePath: string
  name: string
  value: string
}

export default function CarSpecsCard({ imagePath, name, value }: Props) {
  return (
    <div
      className={`
        flex h-[84px] w-full flex-col justify-center gap-2 border-b
        border-neutral-100

        lg:max-w-[182px]
      `}
    >
      <div className="flex items-center gap-[6px]">
        <img className="h-3.5 w-3.5" src={imagePath} alt="detail-icon" />
        <p className="text-subtitle2-semibold uppercase text-neutral-600">
          {name}
        </p>
      </div>
      <p className="text-h5-bold text-neutral-900">{value}</p>
    </div>
  )
}
